export default __webpack_public_path__ + "static/media/Background_00110.fdaae767.png";